<mat-card [ngClass]="{'desktop': isDesktop, 'mobile': !isDesktop}">
  <mat-card-content class="subscription-header">
    <mat-expansion-panel #expansionPanel [hideToggle]="isDesktop" [expanded]="isDesktop" [disabled]="isDesktop">
      <mat-expansion-panel-header collapsedHeight="auto" expandedHeght="auto">
        <mat-panel-title>
          <div class="row">
            <div class="cell cell-title">
              <h1 class="header">{{'subscription.title' | translate}}</h1>
              <h3 class="data">{{subscription.subscriptionName}}</h3>
            </div>
            <div class="cell cell-status">
              <h4 class="header">{{'subscription.status' | translate}}</h4>
              <h3 class="data">{{statusTranslationKeys[subscription.subscriptionStatus] | translate}}</h3>
            </div>
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <ng-container *ngIf="!xhrInProgress">
        <pp-rate-plan [account]="account" *ngFor="let ratePlan of ratePlans" [ratePlan]="ratePlan" (click)="expansionPanel.close()"></pp-rate-plan>
      </ng-container>
    </mat-expansion-panel>
    <div class="spinner" *ngIf="xhrInProgress">
      <mat-progress-spinner color="primary" mode="indeterminate"></mat-progress-spinner>
    </div>
    <div>
      <span id='taxFootnote' *ngIf="showTaxFootnote">* {{'subscription.taxFootnote' | translate}}</span>
    </div>
  </mat-card-content>
</mat-card>
